import axios from 'axios';

export default class DiscoveryAndReportService {
  public getDetailService(docId) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('api/briefing/getDiscoveryDetails?parentDocIds=' + docId)
        // .get('api/briefing/getDiscoveryDetails?parentDocIds=' + '081a7769-223b-44ff-9c34-224fb4a9ccac')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getCountByType(docId, activityType) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('api/briefing/document/getDocumentInformation', {
          params: {
            ids: docId,
            activityTypes: activityType,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getDetailSocialBriefingPage() {
    return new Promise<any>((resolve, reject) => {
      const request = {
        // userKey: null,
        bpId: 'BPID_bf3600c4-f325-4602-9feb-2f0c93047209',
        type: 'BRIEFING_PAGE',
        // subscribeStatus: null
      };
      axios
        .get('api/briefing/social-user-related/get-detail-social-briefing-page', { params: request })
        // .get('api/briefing/getDiscoveryDetails?parentDocIds=' + '081a7769-223b-44ff-9c34-224fb4a9ccac')

        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getDetailServicePublic(docId) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('api/public/getDiscoveryDetails?parentDocIds=' + docId)
        // .get('api/briefing/getDiscoveryDetails?parentDocIds=' + '081a7769-223b-44ff-9c34-224fb4a9ccac')

        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getRelatedArticlesDiscovery(keyword?, page?, lang?, sizes?, sortBy?, ReverseSort?) {
    return new Promise<any>((resolve, reject) => {
      axios
        // .get('/api/related-content/getRelatedDiscovery?keyword=vinfast&page=1&lang=en&size=10&sortBy=basic&ReverseSort=false')
        .get(
          '/api/related-content/getRelatedDiscovery?keyword=' +
            keyword +
            '&page=' +
            page +
            '&lang=' +
            lang +
            '&size=' +
            sizes +
            '&sortBy=' +
            sortBy +
            '&ReverseSort=' +
            ReverseSort
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getRelatedPeopleDiscovery(scrapcardId, userId) {
    const requestBody = {
      userId: userId,
      scrapcardId: scrapcardId,
      // userId: 'UID_61640759-0b8c-41cd-92fa-3cfc8bcf872a',
      // scrapcardId: 'ds-global-news-kor-N9209006967416764955-0-0',
      language: localStorage.getItem('lang-key'),
      peopleNCompany: true,
      infoBox: true,
      stock: true,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/liking/detail-page', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getRelatedReferent(parentDocIds: any[]) {
    // const params = new URLSearchParams();
    // parentDocIds.forEach(id => params.append('parentDocIds', id));
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/briefing/getDiscoveryAndReportDetailsList', parentDocIds)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public checkDocumentTypeForUserKey(userKey: string, parentDocId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/briefing/document/checkDocumentTypeForUserKeys?userKey=${userKey}&parentDocId=${parentDocId}`)
        // .get(
        //   `/api/briefing/document/checkDocumentTypeForUserKeys?userKey=UID_61640759-0b8c-41cd-92fa-3cfc8bcf872a&parentDocId=go-public-web-eng-1713-0-0-1234567`
        // )

        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public uploadFileToS3(filename: string, file: File) {
    const formData = new FormData();
    formData.append('fileName', filename);
    formData.append('file', file);
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/briefing/saveReportFile`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public saveEditedReport(docId: string, documentType: string, docType: number, bpId: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(
          '/api/briefing/saveEditedReport?parentDocIds=' + docId + '&documentType=' + documentType + '&docType=' + docType + '&bpId=' + bpId
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public downloadReportFileFromS3(fileName: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/briefing/downloadReportFile?fileName=${fileName}`, {
          responseType: 'blob',
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getFile(filePath: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/briefing/getFile`, {
          params: { filePath },
          responseType: 'blob',
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
